<template>
    <v-layout column>
        <v-spacer class="my-2"></v-spacer>
        <v-flex xs12>
            <div class="text-xs-left">
                <v-btn
                        flat
                        @click="goBack"
                >
                    <v-icon left small>fal fa-chevron-left</v-icon>
                    {{ $vuetify.t('$vuetify.back') }}
                </v-btn>
            </div>

            <div class="text-xs-center">
                <v-sheet style="background: transparent">{{ supportIntroText }}</v-sheet>
                <v-spacer class="my-5"></v-spacer>
                <v-btn v-if="supportEmailAddress"
                       class="primary"
                       large
                       :href="'mailto:' + supportEmailAddress + '?subject=' + supportSubject"
                >
                    {{ $vuetify.t('$vuetify.send_email') }}
                    <v-icon right small>fal fa-angle-double-right</v-icon>
                </v-btn>
<!--                @modified ana.castro 2019.12.30 SCLAPP-23 -->
                <v-btn v-else-if="supportExternalLink"
                       class="primary"
                       large
                       @click="goToExternalLink"
                >
                    {{ "Contactar" }}
                    <v-icon right small>fal fa-angle-double-right</v-icon>
                </v-btn>
            </div>

        </v-flex>
    </v-layout>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: "Support",
        data: () => ({}),
        methods: {
            //@modified ana.castro 2019.12.03 The "Help" Menu should be replaces by an "Info" Menu with two
            //  options: access the Help page and access the Terms and Conditions page
            goBack() {
                this.$router.push({name: "info-options"});
            },
            // @modified ana.castro 2019.12.30 SCLAPP-23
            goToExternalLink() {
                window.open(this.supportExternalLink);
            },
        },
        computed: {
            ...mapGetters({
                supportEmailAddress: 'configs/supportEmailAddress',
                supportExternalLink: 'configs/supportExternalLink',
                supportSubject: 'configs/supportSubject',
                supportIntroText: 'configs/supportIntroText'
            })
        },

    }
</script>

<style scoped>

</style>